import Vue from "vue";
import App from "@/app/entry/App.vue";
import router from "@/_router";
import store from "@/_store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMoment from "vue-moment";
import vueDebounce from "vue-debounce";
import { initializeApp } from "firebase/app";
import firebaseConfig from "@/_config/firebase";
import VueGeolocation from "vue-browser-geolocation";
import Directives from "@/_directives";
import { isSupported } from "firebase/messaging";
import VueI18n from 'vue-i18n'
import { messages } from '@/_utils/lang'
import i18n from "@/_utils/i18n";
import { configureAxiosInterceptors } from '@/_config/interceptors';
import VeeValidate from 'vee-validate';
import en from "vee-validate/dist/locale/en";
import it from "vee-validate/dist/locale/it";
// import '@/sass/puntofarma/app.scss';
// import it from "moment/locale/it";
// import { getAnalytics } from "firebase/analytics";

import { Validator } from 'vee-validate';

require("moment/locale/it");
require("@/_sass/" + process.env.VUE_APP_SCOPE + "/app.scss");

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueGeolocation);
Vue.use(VueAxios, axios);
Vue.use(VueMoment);
Vue.use(vueDebounce);
Vue.use(Directives);
Vue.config.productionTip = false;
Vue.use(VeeValidate);
Validator.localize('it', it);
// Configura gli interceptor Axios
configureAxiosInterceptors();

Vue.use(VueI18n)

i18n.locale = store.state.lang.locale || "it";
// const i18n = new VueI18n({
//   locale: store.state.lang.locale, // prendi da Vuex
//   fallbackLocale: 'en',
//   messages
// })
//VeeValidate.Validator.localize(it,en);
//VeeValidate.Validator.locale = "it"
store.watch(
  state => state.lang.locale,
  newLocale => {
    i18n.locale = newLocale
  }
)
//Comment inutile
// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// const analytics = getAnalytics(firebaseApp);

// navigator.serviceWorker
//   .register("/" + process.env.VUE_APP_SCOPE + "/firebase-messaging-sw.js")
//   .then((registration) => {
//     console.log("registration", registration);
//   })
//   .catch((err) => {
//     console.log(err);
//   });

isSupported().then((supported) => {
  if (supported) {
    navigator.serviceWorker
      .register("/" + process.env.VUE_APP_SCOPE + "/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("registration", registration);
      })
      .catch((err) => {
        console.error("Service Worker registration failed:", err);
      });
  } else {
    console.warn("Firebase Messaging non supportato su questo browser, Service Worker non registrato.");
  }
});

// if (process.env.VUE_APP_ENVIRONEMENT !== "prod") {
//   require("./sass/puntofarma/app.scss");
// }

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  data() {
    return {
      menuLeft: false,
      isMobile: window.innerWidth <= 576,
      isCollapsed: window.innerWidth <= 767,
      isTablet: window.innerWidth > 576 && window.innerWidth < 1024,
      isLaptop: window.innerWidth >= 1024 && window.innerWidth <= 1440,
      isTabletOrLaptop: window.innerWidth <= 1440 && window.innerWidth > 576,
      isMobileOrTablet: window.innerWidth < 1024,
      prestazioniOnly: process.env.VUE_APP_PRESTAZIONI_ONLY,
      scope: process.env.VUE_APP_SCOPE,
      appName: process.env.VUE_APP_APP_NAME,
      firebaseApp: firebaseApp, 
    };
  },
}).$mount("#app");
